/** App Store Connect id of the production app (`eas.json` → `submit.production.ios.ascAppId`). */
export const APP_STORE_APP_ID = "6817008640";

/** Android application id of the production app (`variant-config.ts` → production `androidPackage`). */
export const GOOGLE_PLAY_PACKAGE_NAME = "dev.improve.haniverse";

export const APP_STORE_URL = `https://apps.apple.com/app/id${APP_STORE_APP_ID}`;

export const GOOGLE_PLAY_URL = `https://play.google.com/store/apps/details?id=${GOOGLE_PLAY_PACKAGE_NAME}`;

/** Web sign-in stays reachable for existing accounts, but the website never promotes it. */
export const LOG_IN_PATH = "/auth";

/**
 * One download link for every device: `GET /download` sends a phone to its store and anything else
 * to the landing page's download section.
 */
export const DOWNLOAD_PATH = "/download";

export type StorePlatform = "android" | "ios";

const ANDROID_USER_AGENT_REGEX = /android/i;
const IOS_USER_AGENT_REGEX = /iphone|ipad|ipod/i;

/** Classify a user agent by the store that serves it; `null` for desktops and everything else. */
export function getStorePlatformFromUserAgent(userAgent: string): StorePlatform | null {
  if (ANDROID_USER_AGENT_REGEX.test(userAgent)) {
    return "android";
  }
  if (IOS_USER_AGENT_REGEX.test(userAgent)) {
    return "ios";
  }
  return null;
}

export function getStoreUrl(platform: StorePlatform): string {
  return platform === "ios" ? APP_STORE_URL : GOOGLE_PLAY_URL;
}
